import { notification } from 'antd';
import md5 from 'md5';
import { BuyerInstance, OfferInstance, OfferInstanceForCreate } from '../ts';
import { Effect } from 'effector';

export const handleSwitch = async (
  id: number,
  state: boolean,
  is_internal: boolean,
  buyerData: any,
  isBuyerEnabled: boolean | undefined,
  { updateOfferFx, reloadSidebarFx, fetchBuyerByIdFx, refetch }: IAdditional,
  isPickup?: boolean,
  offerData?: OfferInstanceForCreate,
) => {
  const dto = isPickup ? {
    id,
    type: buyerData.type,
    dto: offerData as any,
  } : {
    id,
    type: buyerData.type,
    dto: {
      enabled: state === true ? 1 : 0,
      // is_internal,
    } as any,
  }
  const res: any = await updateOfferFx(dto);
  if (res?.error) {
    return notification.error({
      message:
        res?.error || 'Возникла непредвиденная ошибка. Попробуйте, пожалуйста, позже',
    });
  }
  // update company state and sidebar state if buyer_enabled !== isBuyerEnabled
  if (res.buyer_enabled !== undefined && res.buyer_enabled !== isBuyerEnabled) {
    // await updateBuyerFx({
    //   id: buyerData.id,
    //   data: { enabled: res.buyer_enabled },
    //   md5: buyerData.type === 'external' ? md5(buyerData.company_name) : undefined,
    // });
    await reloadSidebarFx();
    await fetchBuyerByIdFx({
      id: buyerData.id,
      md5: buyerData.type === 'external' ? md5(buyerData.company_name) : undefined,
    });
    return;
  } else {
    refetch();
  }
};

interface IAdditional {
  updateOfferFx: (args: {
    id: number;
    type: 'internal' | 'external';
    dto: OfferInstance;
  }) => Promise<void>;
  reloadSidebarFx: () => Promise<BuyerInstance[] | undefined>;
  fetchBuyerByIdFx: Effect<{ id: number; md5?: string | undefined; }, unknown, Error>;
  refetch: () => void;
}
